import React, { FC, memo } from 'react';
import { Text, View } from '@react-pdf/renderer';

import styles from '../pdfStyles';
import { BaseServiceVoucherInfoType } from '../Vouchers/voucherHelpers';

type Props = {
    topDetails: string;
    bottomDetails?: BaseServiceVoucherInfoType['bottomDetails'];
    mainDetailsTopStyle?: object;
    mainDetailsBottomStyle?: object;
    withForLabel?: boolean;
};
const PdfMainDetails: FC<Props> = (props: Props) => {
    const {
        topDetails = 'PDF Title',
        bottomDetails,
        mainDetailsTopStyle,
        mainDetailsBottomStyle,
        withForLabel
    } = props;

    const bottomDetailsText = Array.isArray(bottomDetails)
        ? bottomDetails.map((item) => item.name).join(', ')
        : bottomDetails;
    return (
        <View style={[styles.mainDetails]}>
            <Text style={[styles.mainDetailsTop, mainDetailsTopStyle || {}]}>{topDetails}</Text>
            {bottomDetails && bottomDetailsText && bottomDetailsText !== 'null' && bottomDetailsText !== 'undefined' ? (
                <Text style={[styles.mainDetailsBottom, mainDetailsBottomStyle || {}]}>
                    {`${withForLabel ? 'For: ' : ''}${bottomDetailsText}`}
                </Text>
            ) : (
                <></>
            )}
        </View>
    );
};

export default memo(PdfMainDetails);
